// extracted by css-extract-rspack-plugin
export default {"toolbar":"Toolbar-module__toolbar__UFUUCcV"};